
/*
# /$$$$$$  /$$$$$$$  /$$$$$$ /$$   /$$
# /$$__  $$| $$__  $$|_  $$_/| $$$ | $$
# | $$  \ $$| $$  \ $$  | $$  | $$$$| $$
# | $$  | $$| $$  | $$  | $$  | $$ $$ $$
# | $$  | $$| $$  | $$  | $$  | $$  $$$$
# | $$  | $$| $$  | $$  | $$  | $$\  $$$
# |  $$$$$$/| $$$$$$$/ /$$$$$$| $$ \  $$
# \______/ |_______/ |______/|__/  \__/
*/


//SUCCESS NOTIFICATION (PARAMETERABLE)
var successNotification = function(text){
    $.notify(
        text,
        { position:"right bottom",
            className:'success' }
    );
};

//

//ERROR NOTIFICATION (PARAMETERABLE)
var errorNotification = function(text){
    $.notify(
        text,
        { position:"right bottom",
            className:'error' }
    );
};

var validateEmail = function(email){
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};


/*
$(document).bind("DOMSubtreeModified", function(){
  appendHead();
});*/


function RemoveAccents(s)
{
    var i = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖŐòóôõöőÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜŰùúûüűÑñŠšŸÿýŽž+_.:;[]()/*"<> '.split('');
    var o = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUUuuuuuNnSsYyyZz---------------'.split('');
    var map = {};
    i.forEach(function(el, idx) {map[el] = o[idx]});
    return s.replace(/[^A-Za-z0-9]/g, function(ch) { return map[ch] || ch; }).toLowerCase();
}


function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

function showLoadingOverlay()
{
    $('body').LoadingOverlay("show",{
        background: "rgba(0, 0, 0, 1)",
        image:loader_image
    });
}

$(document).ready(function(){
    baseURL = $("meta[name='baseURL']").attr('content');
    token = $("meta[name='csrf-token']").attr('content');
    Vue.http.headers.common['X-CSRF-Token'] = token;

    jQuery.trumbowyg.defaultOptions.btnsDef = {
        indent: {
            fn: 'indent',
            title: 'Indent',
            isSupported: function () { return !!document.queryCommandSupported && !!document.queryCommandSupported('indent'); },
            hasIcon: false
        },
        outdent: {
            fn: 'outdent',
            title: 'Outdent',
            isSupported: function () { return !!document.queryCommandSupported && !!document.queryCommandSupported('outdent'); },
            hasIcon: false
        }
    };

});


